import React, { useState, useEffect } from "react";
import { ClipboardList, CheckCircle, Play, ChevronRight } from "lucide-react";
import { useNavigate } from "react-router-dom";
import TopBar from "../components/TopBar";
import './css/MCQTests.css';
import axios from "./../axios";

const MCQTests = ({ setSideBar, setSettingDrawer }) => {
  const navigate = useNavigate();
  const [selectedSubject, setSelectedSubject] = useState("All");
   const [subjects, setSubjects] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [tests, setTests] = useState([
    { id: "1", topic: "Algebra Basics", subjects_id: 1, attempted: true, marks: 85 },
    { id: "2", topic: "Geometry Quiz", subjects_id: 1, attempted: false },
    { id: "3", topic: "Physics Fundamentals", subjects_id: 2, attempted: true, marks: 70 },
    { id: "4", topic: "Chemistry Basics", subjects_id: 2, attempted: false },
    { id: "5", topic: "Literature Quiz", subjects_id: 256, attempted: false },
  ]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setIsLoading(true);
        const token = localStorage.getItem("student_token");

        const [subjectsResponse, testsResponse] = await Promise.all([
          axios.get('student/subjects', {
            headers: { Authorization: `Bearer ${token}` },
          }),
          axios.get('student/mcq', {
            headers: { Authorization: `Bearer ${token}` },
          }),
        ]);

        setSubjects([{ name: 'All' }, ...subjectsResponse.data]);
        setTests(testsResponse.data);
      } catch (error) {
        console.error('Error fetching data:', error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
  }, []);

  // Filter tests based on selected subject
  const filteredTests = selectedSubject === "All" 
    ? tests 
    : tests.filter(test => {
        const subject = subjects.find(s => s.id === test.subjects_id);
        return subject && subject.name === selectedSubject;
      });

  return (
    <>
      <TopBar title="MCQ Tests" setSideBar={setSideBar} setSettingDrawer={setSettingDrawer} />
      <div className="mcq-tests-container">
        <div className="mcq-tests-header">
          <ClipboardList size={20} className="header-icon" />
          <h2>MCQ Tests</h2>
        </div>
        {isLoading ? (
          <div className="animate-pulse">
            <div className="subject-tabs flex space-x-2 mb-4">
              {[...Array(4)].map((_, index) => (
                <div
                  key={index}
                  className="h-10 w-24 bg-gray-200 rounded"
                ></div>
              ))}
            </div>
            <div className="test-list space-y-4">
              {[...Array(3)].map((_, index) => (
                <div
                  key={index}
                  className="test-item flex items-center p-4 bg-white rounded shadow"
                >
                  <div className="test-icon h-8 w-8 bg-gray-200 rounded-full mr-4"></div>
                  <div className="test-content flex-1">
                    <div className="h-5 w-3/4 bg-gray-200 rounded mb-2"></div>
                    <div className="h-4 w-1/2 bg-gray-200 rounded"></div>
                  </div>
                  <div className="h-5 w-5 bg-gray-200 rounded mr-2"></div>
                </div>
              ))}
            </div>
          </div>
        ) : (
          <>
            <div className="subject-tabs">
              {subjects.map((subject) => (
                <button
                  key={subject.id}
                  className={`tab ${selectedSubject === subject.name ? "active" : ""}`}
                  onClick={() => setSelectedSubject(subject.name)}
                >
                  {subject.name}
                </button>
              ))}
            </div>
            <div className="test-list">
              {filteredTests.map((test) => (
                <div
                  key={test.id}
                  className="test-item"
                  onClick={() => navigate(`/student/mcq-test/${test.id}`)}
                >
                  <div className="test-icon">
                    <ClipboardList size={18} />
                  </div>
                  <div className="test-content">
                    <span className="test-topic">{test.topic}</span>
                    <div className="test-meta">
                      <span className="subject">
                        <CheckCircle size={14} /> {subjects.find(s => s.id === test.subjects_id)?.name || 'Unknown'}
                      </span>
                      {test.attempted ? (
                        <div className="progress-wrapper">
                          <span className="progress-label">Score: {test.marks}%</span>
                          <div className="progress-bar">
                            <div
                              className="progress-fill"
                              style={{ width: `${test.marks}%` }}
                            ></div>
                          </div>
                        </div>
                      ) : (
                        <button className="attempt-button">
                          <Play size={14} /> Attempt
                        </button>
                      )}
                    </div>
                  </div>
                  <ChevronRight size={18} className="chevron" />
                </div>
              ))}
              {filteredTests.length === 0 && (
                <div className="no-tests">No tests for {selectedSubject}</div>
              )}
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default MCQTests;